import React from 'react';
import { Snackbar, Button } from '@mui/material';
import { usePWAInstall } from '../hooks/usePWAInstall';
import { FEATURE_FLAGS } from '../config/app.config';

export function InstallPrompt() {
  const { installable, prompt, dismissed, dismiss } = usePWAInstall();

  if (!FEATURE_FLAGS.PWA_INSTALL || !installable || dismissed) return null;

  const handleInstall = () => {
    if (prompt) prompt.prompt();
    dismiss();
  };

  return (
    <Snackbar
      open={installable && !dismissed}
      message="Install Infinity Sport ERP for a better experience"
      action={
        <>
          <Button color="primary" size="small" onClick={handleInstall}>
            Install
          </Button>
          <Button color="inherit" size="small" onClick={dismiss}>
            Not now
          </Button>
        </>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    />
  );
}
